<template>
  <div class="shadow-container">
    <slot name="contain"></slot>
    <div class="gradient-container">
      <div class="followers-gradient scroll lg:inline-block hidden"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
.shadow-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
</style>
